import {
  AccountCircleOutlined,
  AddOutlined,
  CachedOutlined,
  Clear,
  CloseOutlined,
  DeleteOutlined,
  Done,
  DoneOutline,
  ErrorOutlineOutlined,
  ExitToAppOutlined,
  KeyboardArrowDownOutlined,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
  KeyboardArrowUpOutlined,
  VisibilityOffOutlined,
  VisibilityOutlined,
  PauseCircleOutline,
  PlayCircleOutline,
} from '@material-ui/icons';
import { Icon } from '@material-ui/core';
import check from '../styles/icon/check.png';
import edit from '../styles/icon/edit.svg';
import edit_outlined from '../styles/icon/edit_outlined.svg';
import readmeLock from '../styles/icon/readme-lock.png';
import readmePencil from '../styles/icon/readme-pencil.png';
import readmePower from '../styles/icon/readme-power.png';
import circleGreen from '../styles/icon/circle-green.svg';
import circleGray from '../styles/icon/circle_gray.svg';
import baeLogoIcon from '../styles/icon/bae-logo-icon.svg';
import baeLogoIconContained from '../styles/icon/bae-logo-icon-contained.svg';
import baeMessaging from '../styles/icon/messaging.svg';
import headerGetStarted from '../styles/icon/header/get-started.svg';
import headerApis from '../styles/icon/header/apis.svg';
import headerApps from '../styles/icon/header/apps.svg';
import headerDiscussions from '../styles/icon/header/discussions.svg';
import headerSupport from '../styles/icon/header/support.svg';
import headerFintoIo from '../styles/icon/header/staq-io.svg';
import headerArrow from '../styles/icon/header/arrow.svg';
import headerProfile from '../styles/icon/header/profile.svg';
import headerLogOut from '../styles/icon/header/logout.svg';
import headerDocs from '../styles/icon/header/docs.svg';
import home from '../styles/icon/header/home.svg';
import b2b from '../styles/icon/card/b2b.svg';
import info from '../styles/icon/info.svg';
import system from '../styles/icon/system.svg';
import downArrow from '../styles/icon/header/arrow.svg';
import arrowPink from '../styles/icon/header/arrow-pink.svg';
import trash from '../styles/icon/trash.svg';
import uploadFile from '../styles/icon/upload_file.svg';
import resetDone from '../styles/icon/reset_done.svg';
import resetError from '../styles/icon/reset_error.svg';
import profile from '../styles/icon/header/profile.svg';
import logout from '../styles/icon/header/logout.svg';
import search from '../styles/icon/search.svg';
import keyboard from '../styles/icon/keyboard.svg';
import star from '../styles/icon/star.svg';
import delet from '../styles/icon/delete.svg';
import arrowBack from '../styles/icon/arrow-back.svg';
import key from '../styles/icon/key.svg';
import checkCircle from '../styles/icon/check-circle.svg';
import refresh from '../styles/icon/refresh.svg';
import save from '../styles/icon/save.svg';
import warning from '../styles/icon/warning.png';
import certificate from '../styles/icon/certificate.svg';
import sdk from '../styles/icon/sdk.svg';
import guidesIcon from '../styles/icon/menu/guides.svg';

function createIcon(src, alt) {
  return function (props) {
    return (
      <Icon {...props}>
        <img src={src} alt={alt} />
      </Icon>
    );
  };
}

const icons = {
  arrowDown: KeyboardArrowDownOutlined,
  arrowUp: KeyboardArrowUpOutlined,
  arrowRight: KeyboardArrowRightOutlined,
  arrowLeft: KeyboardArrowLeftOutlined,
  delete: DeleteOutlined,
  account: AccountCircleOutlined,
  exit: ExitToAppOutlined,
  error: ErrorOutlineOutlined,
  done: DoneOutline,
  apply: Done,
  close: CloseOutlined,
  visibility: VisibilityOutlined,
  visibilityOff: VisibilityOffOutlined,
  cached: CachedOutlined,
  add: AddOutlined,
  pause: PauseCircleOutline,
  play: PlayCircleOutline,
  circleGreen: createIcon(circleGreen, 'circleGreen'),
  circleGray: createIcon(circleGray, 'circleGray'),
  check: createIcon(check, 'check'),
  edit: createIcon(edit, 'edit'),
  editOutlined: createIcon(edit_outlined, 'edit_outlined'),
  readmePower: createIcon(readmePower, 'readmePower'),
  readmePencil: createIcon(readmePencil, 'readmePencil'),
  readmeLock: createIcon(readmeLock, 'readmeLock'),
  baeLogoIcon: createIcon(baeLogoIcon, 'baeLogoIcon'),
  baeLogoIconContained: createIcon(baeLogoIconContained, 'baeLogoIconContained'),
  clear: Clear,
  messaging: createIcon(baeMessaging, 'baeMessaging'),
  headerGetStarted: createIcon(headerGetStarted, 'headerGetStarted'),
  headerApis: createIcon(headerApis, 'headerApis'),
  headerApps: createIcon(headerApps, 'headerApps'),
  headerDiscussions: createIcon(headerDiscussions, 'headerDiscussions'),
  headerSupport: createIcon(headerSupport, 'headerSupport'),
  headerFintoIo: createIcon(headerFintoIo, 'headerFintoIo'),
  headerArrow: createIcon(headerArrow, 'headerArrow'),
  headerProfile: createIcon(headerProfile, 'headerProfile'),
  headerLogOut: createIcon(headerLogOut, 'headerLogOut'),
  headerDocs: createIcon(headerDocs, 'headerDocs'),
  guidesIcon: createIcon(guidesIcon, 'guidesIcon'),
  home: createIcon(home, 'home'),
  b2b: createIcon(b2b, 'b2b'),
  info: createIcon(info, 'info'),
  system: createIcon(system, 'system'),
  downArrow: createIcon(downArrow, 'downArrow'),
  arrowPink: createIcon(arrowPink, 'arrowPink'),
  trash: createIcon(trash, 'trash'),
  search: createIcon(search, 'search'),
  keyboard: createIcon(keyboard, 'keyboard'),
  star: createIcon(star, 'star'),
  delet: createIcon(delet, 'delet'),
  arrowBack: createIcon(arrowBack, 'arrowBack'),
  checkCircle: createIcon(checkCircle, 'checkCircle'),
  save: createIcon(save, 'save'),
  refresh: createIcon(refresh, 'refresh'),
  key: createIcon(key, 'key'),
  uploadFile: createIcon(uploadFile, uploadFile),
  resetDone: createIcon(resetDone, 'reset_done'),
  resetError: createIcon(resetError, 'reset_error'),
  profile: createIcon(profile, 'profile'),
  logout: createIcon(logout, 'logout'),
  warning: createIcon(warning, 'warning'),
  certificate: createIcon(certificate, 'certificate'),
  sdk: createIcon(sdk, 'sdk'),
} as any;

export default icons;
